import { Navbar} from "./componnents/Navbar"
import './App.css';
import { Contact } from "./componnents/contact";
import{Footer} from "./componnents/footer"
import {  Testim} from "./componnents/testim";
import { Prod } from "./componnents/prod";
import { Main } from "./componnents/main";
import { Adventure } from "./componnents/adventure";
function App() {
  return (
    <>
    <Navbar />
    <Main />
    <Adventure /> 
    <Prod />
    <Testim />
    <Contact />
    <Footer />
    </>
    
   
  )
}

export default App;
